import { render, staticRenderFns } from "./BloqueioImediado.vue?vue&type=template&id=a69953e8"
import script from "./BloqueioImediado.vue?vue&type=script&lang=js"
export * from "./BloqueioImediado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports